module.exports = __webpack_public_path__ + "static/media/ingredients-coconut.aeb60214.png";